import { alpha, createTheme } from "@mui/material/styles";

const brand = "#2563eb";

export const createAppTheme = (direction = "ltr") => createTheme({
  direction,
  palette: {
    mode: "light",
    primary: { main: brand, dark: "#1d4ed8", light: "#60a5fa" },
    secondary: { main: "#7c3aed" },
    success: { main: "#16a34a" },
    warning: { main: "#d97706" },
    error: { main: "#dc2626" },
    info: { main: "#0284c7" },
    background: { default: "#f4f7fb", paper: "#ffffff" },
    text: { primary: "#0f172a", secondary: "#64748b" },
    divider: "#e2e8f0",
  },
  shape: { borderRadius: 16 },
  typography: {
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    h1: { fontWeight: 900, letterSpacing: "-0.04em" },
    h2: { fontWeight: 900, letterSpacing: "-0.035em" },
    h3: { fontWeight: 900, letterSpacing: "-0.03em" },
    h4: { fontWeight: 900, letterSpacing: "-0.028em" },
    h5: { fontWeight: 850, letterSpacing: "-0.02em" },
    h6: { fontWeight: 850, letterSpacing: "-0.015em" },
    button: { fontWeight: 800, textTransform: "none" },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "*": { boxSizing: "border-box" },
        html: { scrollBehavior: "smooth" },
        body: { backgroundColor: "#f4f7fb", scrollbarColor: "#cbd5e1 transparent" },
        "::selection": { backgroundColor: alpha(brand, 0.16) },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 12, minHeight: 42, paddingInline: 18 },
        containedPrimary: {
          background: "linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)",
          boxShadow: `0 12px 26px ${alpha(brand, 0.22)}`,
          "&:hover": { boxShadow: `0 15px 32px ${alpha(brand, 0.28)}` },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          border: "1px solid #e2e8f0",
          boxShadow: "0 14px 38px rgba(15, 23, 42, 0.055)",
          backgroundImage: "none",
          overflow: "hidden",
        },
      },
    },
    MuiCardActionArea: {
      styleOverrides: { root: { transition: "transform .18s ease, background-color .18s ease" } },
    },
    MuiCardContent: { styleOverrides: { root: { "&:last-child": { paddingBottom: 24 } } } },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          backgroundColor: "#fff",
          transition: "box-shadow .16s ease, background-color .16s ease",
          "&.Mui-focused": { boxShadow: `0 0 0 4px ${alpha(brand, 0.09)}` },
        },
      },
    },
    MuiChip: { styleOverrides: { root: { fontWeight: 750, borderRadius: 9 } } },
    MuiAlert: {
      styleOverrides: {
        root: { borderRadius: 14, border: "1px solid" },
        standardInfo: { borderColor: "#bfdbfe" },
        standardSuccess: { borderColor: "#bbf7d0" },
        standardWarning: { borderColor: "#fde68a" },
        standardError: { borderColor: "#fecaca" },
      },
    },
    MuiDialog: { styleOverrides: { paper: { borderRadius: 22, border: "1px solid #e2e8f0" } } },
    MuiTableContainer: { styleOverrides: { root: { borderRadius: 16, border: "1px solid #e2e8f0" } } },
    MuiTableCell: {
      styleOverrides: {
        root: { borderColor: "#edf2f7" },
        head: { color: "#475569", fontWeight: 850, backgroundColor: "#f8fafc" },
      },
    },
    MuiTabs: { styleOverrides: { indicator: { height: 3, borderRadius: 3 } } },
    MuiTab: { styleOverrides: { root: { minHeight: 48, textTransform: "none", fontWeight: 800 } } },
    MuiTooltip: { styleOverrides: { tooltip: { borderRadius: 8, fontWeight: 700 } } },
  },
});

export default createAppTheme();
